var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState, useEffect } from "react";
import { observer } from "mobx-react-lite";
import copy from "copy-to-clipboard";
import translate from "@/utilities/i18n/getTranslate";
import { k } from "@/utilities/i18n";
import useAdminStore from "@/services/store/useAdminStore";
import api from "@/api/admin";
import { useAcl } from "@/api/auth/useAcl";
import errorHandler from "@/utilities/errorHandler";
import { BankTransferInfo } from "@gcp-artifact/compass/lib/components";
var BankTransferDialog = function (_a) {
    var invoiceId = _a.invoiceId, amount = _a.amount, currency = _a.currency, accountId = _a.accountId, paymentReference = _a.paymentReference, onClose = _a.onClose, onBack = _a.onBack;
    var adminNotification = useAdminStore().adminNotification;
    var partnerId = useAcl().partnerId;
    var _b = __read(useState(false), 2), isLoading = _b[0], setIsLoading = _b[1];
    var _c = __read(useState(false), 2), loadingInstructions = _c[0], setLoadingInstructions = _c[1];
    var _d = __read(useState(false), 2), isPdfLoading = _d[0], setIsPdfLoading = _d[1];
    var _e = __read(useState(null), 2), bankTransferData = _e[0], setBankTransferData = _e[1];
    var _f = __read(useState(null), 2), instructions = _f[0], setInstructions = _f[1];
    useEffect(function () {
        if (partnerId) {
            createBankTransferInvoice();
            fetchBankTransferInstructions();
        }
    }, [partnerId]);
    var createBankTransferInvoice = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!partnerId || invoiceId)
                        return [2 /*return*/];
                    setIsLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, api.partners.post.pbsInvoiceManualNew({
                            partnerId: partnerId,
                            fsAccountId: accountId || "",
                            amount: parseFloat(amount),
                            currency: currency,
                            reason: "Manual top-up via Bank Transfer"
                        })];
                case 2:
                    response = _a.sent();
                    setIsPdfLoading(true);
                    setBankTransferData({
                        billId: response.billId,
                        bankTransferPaymentReference: response.bankTransferPaymentReference,
                        accountNumber: response.accountNumber,
                        accountCurrency: response.accountCurrency,
                        bankAddress: response.bankAddress
                    });
                    adminNotification.add({
                        type: adminNotification.types.SUCCESS,
                        timeoutToClose: 3,
                        message: translate(k.BILL_bankTransferInvoiceCreated)
                    });
                    // Simulate PDF preparation time
                    setTimeout(function () {
                        setIsPdfLoading(false);
                    }, 10000);
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    adminNotification.add({
                        type: adminNotification.types.ERROR,
                        timeoutToClose: 10,
                        message: errorHandler(error_1, translate(k.ERR_failedToCreateBankTransferInvoice))
                    });
                    onBack();
                    return [3 /*break*/, 5];
                case 4:
                    setIsLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var fetchBankTransferInstructions = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    setLoadingInstructions(true);
                    return [4 /*yield*/, api.accounting.get.bankTransferInstructions()];
                case 1:
                    response = _a.sent();
                    setInstructions(response);
                    return [3 /*break*/, 4];
                case 2:
                    error_2 = _a.sent();
                    console.error("Failed to fetch bank transfer instructions:", error_2);
                    return [3 /*break*/, 4];
                case 3:
                    setLoadingInstructions(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleCopyToClipboard = function (text, label) {
        var copied = copy(text || "");
        if (copied) {
            adminNotification.add({
                type: adminNotification.types.SUCCESS,
                timeoutToClose: 3,
                message: "".concat(label, " ").concat(translate(k.SH_copied))
            });
        }
    };
    var handleDownloadPdf = function () { return __awaiter(void 0, void 0, void 0, function () {
        var data, file, fileURL, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!partnerId)
                        return [2 /*return*/];
                    setIsPdfLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, api.partners.get.partnerInvoiceAsPDF({
                            partnerId: partnerId,
                            invoiceId: bankTransferData === null || bankTransferData === void 0 ? void 0 : bankTransferData.billId
                        })];
                case 2:
                    data = _a.sent();
                    file = new Blob([data], { type: "application/pdf" });
                    fileURL = URL.createObjectURL(file);
                    window.open(fileURL, "_blank", "noopener,noreferrer");
                    return [3 /*break*/, 5];
                case 3:
                    error_3 = _a.sent();
                    adminNotification.add({
                        type: adminNotification.types.ERROR,
                        timeoutToClose: 10,
                        message: errorHandler(error_3, translate(k.ERR_downloadingInvoicePDFError))
                    });
                    return [3 /*break*/, 5];
                case 4:
                    setIsPdfLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement(BankTransferInfo, { invoiceId: invoiceId, amount: amount, currency: currency, paymentReference: paymentReference || (bankTransferData === null || bankTransferData === void 0 ? void 0 : bankTransferData.bankTransferPaymentReference), isLoading: isLoading, loadingInstructions: loadingInstructions, isPdfLoading: isPdfLoading, bankTransferData: bankTransferData, instructions: instructions, onClose: onClose, onBack: onBack, onDownloadPdf: handleDownloadPdf, onCopyToClipboard: handleCopyToClipboard }));
};
export default observer(BankTransferDialog);
//# sourceMappingURL=data:application/json;base64,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